<script>
  import InputWithValidation from '../../../lib/components/InputField.svelte';
  import DatePicker from '../../../lib/components/DatePicker.svelte';
  import Selector from '../../../lib/components/Selector.svelte';
  import session from '../../../lib/session';
  import { t9n } from '../../../lib/translate';
  import { compareStrings } from '../../../lib/utils';
  import { TS } from '../../../config/translation-keys.js';
  import { fade } from "svelte/transition"

  export let filters;
  export let show_filters;
  export let reset;

  let labels = {
    start: null,
    init: null,
    order: null,
    sorting: null,
    product: null,
    team: null,
    worker: null,
    city: null,
  };

  let category_selector_items = [];
  let order_by_items = [
    {
      name: 'Initial start date',
      raw_name: 'Initial start date',
      val: 'initial_start_date',
    },
    {
      name: 'Worker email',
      raw_name: 'Worker email',
      val: 'worker_email',
    },
  ];

  let sort_items = [
    {
      name: 'Descending',
      raw_name: 'Descending',
      val: false,
    },
    {
      name: 'Ascending',
      raw_name: 'Ascending',
      val: true,
    },
  ];

  const get_name_of_product = localized_names => {
    for (let [key, value] of Object.entries(localized_names)) {
      if (key.includes($session.language)) {
        return value;
      }
    }
  };

  const get_categories = () => {
    let merchant = $session.merchant;
    for (let j = 0; j < merchant.products.length; j++) {
      let is_deleted = merchant.products[j].is_deleted;

      if (!is_deleted) {
        let no_payment = merchant.products[j].no_payment;
        let name = get_name_of_product(merchant.products[j].localized_names);
        let price = merchant.products[j].orderer_price.toFixed(2);
        let sign = merchant.currency_sign;
        let based_on = merchant.products[j].based_on;
        let new_item;

        if (!no_payment) {
          let item_name;
          if (based_on === 'product_based_price') {
            item_name = `${name} (${sign}) - ${t9n(based_on)}`;
          } else {
            item_name = `${name} (${price} ${sign}) - ${t9n(based_on)}`;
          }
          new_item = {
            name: item_name,
            raw_name: name,
            val: merchant.products[j].product_id,
            no_payment: no_payment,
          };
        } else {
          new_item = {
            name: `${name}`,
            raw_name: name,
            val: merchant.products[j].product_id,
            no_payment: no_payment,
          };
        }

        let tmp_name = new_item.name;
        let last_char_index = tmp_name.length - 1;
        if (tmp_name[last_char_index] === ' ') {
          new_item.name = tmp_name.slice(0, -1);
        }
        category_selector_items.push(new_item);
      }
    }
    //   }
    // }
    category_selector_items.sort((a, b) => {
      return compareStrings(a.name, b.name);
    });
  };

  const translate_texts = () => {
    order_by_items[0].name = t9n(TS.TABLE_FILTERS_INIT_DATE);
    order_by_items[0].raw_name = t9n(TS.TABLE_FILTERS_INIT_DATE);
    order_by_items[1].name = t9n(TS.TABLE_FILTERS_WORKER);
    order_by_items[1].raw_name = t9n(TS.TABLE_FILTERS_WORKER);
    sort_items[0].name = t9n(TS.TABLE_FILTERS_DESCENDING);
    sort_items[0].raw_name = t9n(TS.TABLE_FILTERS_DESCENDING);
    sort_items[1].name = t9n(TS.TABLE_FILTERS_ASCENDING);
    sort_items[1].raw_name = t9n(TS.TABLE_FILTERS_ASCENDING);

    labels.start = t9n(TS.TABLE_FILTERS_START);
    labels.init = t9n(TS.TABLE_FILTERS_INIT_ORDER);
    labels.order = t9n(TS.TABLE_FILTERS_ORDERBY);
    labels.sorting = t9n(TS.TABLE_FILTERS_SORTING);
    labels.product = t9n(TS.TABLE_FILTERS_PRODUCT);
    labels.team = t9n(TS.TABLE_FILTERS_TEAM);
    labels.worker = t9n(TS.TABLE_FILTERS_WORKER);
    labels.city = t9n(TS.TABLE_FILTERS_CITY);
  };

  $: if (!!$session.api_config) {
    get_categories();
    translate_texts();
  }
</script>

{#if show_filters}
  {#each reset as key (key)}
    <div style='margin-top: 17px;' in:fade>
      <div class='filter-wrap' style='display: flex;'>
        <div class='margin-17'>
          <DatePicker
            id='filters-field-9'
            label={labels.start}
            height='40px'
            width='213px !important'
            bind:value={filters.start_date} />
        </div>

        <InputWithValidation
          id='filters-field-0'
          label={labels.init}
          margin_left='17px'
          height='40px'
          bind:value={filters.initial_order_time}
          width='213px !important' />

        <Selector
          id='filters-field-5'
          label={labels.order}
          items={order_by_items}
          height='40px'
          width='213px !important'
          margin_left='17px'
          bind:value={filters.order_by} />

        <Selector
          id='filters-field-8'
          label={labels.sorting}
          items={sort_items}
          height='40px'
          width='213px !important'
          margin_left='17px'
          bind:value={filters.order_ascending} />
      </div>

      <div class='filter-wrap ' style='display: flex;'>
        <div class='margin-17'>
          <Selector
            id='filters-field-1'
            label={labels.product}
            items={category_selector_items}
            height='40px'
            width='213px !important'
            bind:value={filters.product_name} />
        </div>

        <InputWithValidation
          id='filters-field-2'
          label={labels.team}
          height='40px'
          bind:value={filters.team_code}
          margin_left='17px'
          width='213px !important' />

        <InputWithValidation
          id='filters-field-4'
          label={labels.worker}
          height='40px'
          bind:value={filters.worker_email}
          margin_left='17px'
          width='213px !important' />

        <InputWithValidation
          id='filters-field-3'
          label={labels.city}
          height='40px'
          bind:value={filters.city_name}
          margin_left='17px'
          width='213px !important' />
      </div>
    </div>
  {/each}
{/if}


<style type='text/scss'>
  /* Tablet + mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 1024px) {

    .margin-17 {
      margin-left: 17px;
    }

    .filter-wrap {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 15px;
    }
  }
</style>